import "../../utils/tailwind.css";
import { PageProvider, useContactProvider } from "./provider";

import { Accordion } from "react-bootstrap";
import { Formik, Form } from "formik";

import Section from "../../components/section";
import Label from "../../components/label";
import { FormikInput } from "../../components/input";
import Button from "../../components/Buttons";
import { Textarea } from "../../components/textarea";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit } = useContactProvider();
  return (
    <Section>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <Form>
            <Accordion defaultActiveKey="0" alwaysOpen>
              <Accordion.Item eventKey="1">
                <Accordion.Header>SEO Meta</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="flex flex-col">
                      <Label label="Meta Title" className="mb-2 text-black text-[15px]" />
                      <FormikInput name="meta.meta_title" rootClassName="w-full" />
                    </div>
                   
                    <div className="flex flex-col">
                      <Label label="Meta Keywords" className="mb-2 text-black text-[15px]" />
                      <FormikInput name="meta.keywords" rootClassName="w-full" as="textarea" className="h-[26rem]" />
                    </div>
                    <div className="flex flex-col ">
                      <Label label="Meta Description" className="mb-2 text-black text-[15px]" />
                      <FormikInput name="meta.meta_description" rootClassName="w-full" as="textarea" className="h-[26rem]" />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>Contact Us</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="contact.heading"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="SubHeading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="contact.description"
                        rootClassName="w-full" as="textarea"
                      />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>Information</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="information.heading"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="SubHeading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="information.subheading"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-3 mt-3 ">
                    <div className="flex flex-col">
                      <Label
                        label="Phone Number"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="information.mobile_no"
                        type="number"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="Email Address"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="information.email"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <Label
                      label="Address"
                      className="mb-2 text-black text-[15px]"
                    />
                    <Textarea
                      value={formik.values.information.address}
                      onChange={(e) =>
                        formik.setFieldValue(
                          "information.address",
                          e.target.value
                        )
                      }
                      minRows={4}
                      name="information.address"
                      rootClassName="w-full"
                    />
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <div className="fixed bottom-0 left-0 w-full bg-white flex justify-end items-center py-3 pr-4 space-x-3 shadow-md">
              <Button type="submit">Save</Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
